import * as React from "react";
import { useRef } from "react";
import "./ItemLabelText.scss";

export interface IItemLabelTextprops {
  label: string;
  hasWarning?: boolean;
}

export const ItemLabelText = (props: IItemLabelTextprops) => {
  const itemLabelSpan = useRef(null);

  return (
    <span className="item-label" ref={itemLabelSpan}>
      {props.label}
      {props.hasWarning && <span className="label-icon">!</span>}
    </span>
  );
};
